import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  searchContainer: {
    width: '30%'
  }
});

export default useStyles;
